import { Fragment } from "react";
import "./HiringSection.css";

const HiringSection = () => {
  return (
    <Fragment>
      <section className="hire-section">
        <div className="hire-parallax">
          <div className="hire-card">
            <h1>We Are Hiring!</h1>
            <p className="mt-3">
              Kairaa is looking for talented and passionate people to join us in
              our mission to empower everyone through technology!
            </p>
            <div className="mt-4">
              <button className="hire-btn">
                <span>Join With Us</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default HiringSection;
